import React, { useState } from 'react';
import styles from './GymRow.module.scss';
import classNames from 'classnames';
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import Menu from '../atoms/Menu';
import AssetThumbnail from '../atoms/AssetThumbnail';

import type { Gym } from '../../types';

interface GymRowProps {
  gym: Gym;
  selected: boolean;
  onSelect?: () => void;
}

const GymRow: React.FC<GymRowProps> = ({ gym, onSelect, selected }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleCloseMenuOptions = () => {
    setAnchorEl(null);
  };

  const renderGymName = () => {
    const gymName = gym.name;
    return (
      <div className={classNames(styles.gymColumn, styles.gymName)}>
        {gymName}
      </div>
    );
  };

  const renderGymLogo = () => {
    return (
      <div className={classNames(styles.gymColumn, styles.logoContainer)}>
        <AssetThumbnail
          src={gym.logoUrl}
          context="gym"
          alt={`${gym.name} logo`}
          className={styles.image}
          fit="contain"
        />
      </div>
    );
  };

  const renderMoreOptions = () => {
    const menuOptions = [
      {
        onClick: () => {
          handleCloseMenuOptions();
          if (onSelect) {
            onSelect();
          }
        },
        label: 'Gym Settings',
        icon: <SettingsApplicationsIcon color="primary" />,
      },
    ];
    return (
      <div className={classNames(styles.gymColumn, styles.options)}>
        <PendingOutlinedIcon
          className={styles.optionsBtn}
          color="primary"
          onClick={(event) => {
            event.stopPropagation();
            setAnchorEl(event.currentTarget as unknown as HTMLElement);
          }}
        />
        <Menu
          anchorEl={anchorEl}
          isOpen={open}
          onClose={handleCloseMenuOptions}
          options={menuOptions}
        />
      </div>
    );
  };

  const handleRowClick = () => {
    // Don't trigger row selection if menu is open
    // Let the menu close naturally when clicking away
    if (!open && onSelect) {
      onSelect();
    }
  };

  return (
    <div
      onClick={handleRowClick}
      className={classNames(styles.gymRow, styles.listGrid, {
        [styles.selected]: selected,
      })}
    >
      {renderGymName()}
      {renderGymLogo()}
      {renderMoreOptions()}
    </div>
  );
};

export default GymRow;
